import QuesntionsBody from "./QuesntionsBody";
import QuesntionsHeader from "./QuesntionsHeader";
import { useQuestionsForm } from "@/store/useQuestionsForm";

const QuestionsTable = () => {
  const { questions } = useQuestionsForm();
  return (
    <div className="border border-l border-ib-gray-lightest rounded-[8px]">
      <table className="w-full">
        <thead>
          <QuesntionsHeader />
        </thead>
        <tbody>
          <QuesntionsBody questions={questions} />
        </tbody>
      </table>
    </div>
  );
};

export default QuestionsTable;
